// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"QuestProgress_wrapper_2_Xqc","title":"QuestProgress_title_2WPlc","completed":"QuestProgress_completed_2in4Y"};